var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioButtonCurrent2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3920_141000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0052 1.67188C5.40521 1.67188 1.67188 5.40521 1.67188 10.0052C1.67188 14.6052 5.40521 18.3385 10.0052 18.3385C14.6052 18.3385 18.3385 14.6052 18.3385 10.0052C18.3385 5.40521 14.6052 1.67188 10.0052 1.67188ZM10.0052 13.0039C8.34799 13.0046 7.00391 11.6611 7.00391 10.0039C7.00391 8.34705 8.34705 7.00391 10.0039 7.00391C11.6611 7.00391 13.0046 8.34799 13.0039 10.0052C13.0032 11.6613 11.6613 13.0032 10.0052 13.0039Z",
    fill: "#44546F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3920_141000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonCurrent2);
export default __webpack_public_path__ + "static/media/radio_button_current2.1053a1499eb7c9c3c192f76fa95afe3a.svg";
export { ForwardRef as ReactComponent };